import React from 'react';
import { motion } from 'framer-motion';
import { Clock, MapPin, Volume2, Wifi } from 'lucide-react';

const features = [
  {
    icon: Clock,
    title: "Real-time Availability",
    description: "See which classrooms are empty right now, updated instantly."
  },
  {
    icon: Volume2,
    title: "Noise Levels",
    description: "Find the perfect silence for focus or a buzz for group work."
  },
  {
    icon: MapPin,
    title: "Campus-wide",
    description: "Detailed info for every major building and study spot."
  },
  {
    icon: Wifi,
    title: "Amenities",
    description: "Filter by power outlets, whiteboards, and accessibility."
  }
];

const Features = () => {
  return (
    <section className="py-24 px-4 relative">
      <div className="max-w-7xl mx-auto">
        <motion.div 
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6"
        >
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="group relative p-8 rounded-3xl overflow-hidden"
            >
              {/* Subtle card background */}
              <div className="absolute inset-0 bg-white/[0.02] group-hover:bg-white/[0.04] transition-colors duration-500" />
              
              {/* Hover gradient glow */}
              <div className="absolute inset-0 bg-gradient-to-br from-purple-500/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              
              <div className="relative z-10">
                <div className="h-14 w-14 rounded-2xl bg-white/[0.05] flex items-center justify-center mb-6 text-purple-300 group-hover:text-purple-200 group-hover:scale-110 transition-all duration-500 group-hover:bg-purple-500/20">
                  <feature.icon size={26} strokeWidth={1.5} />
                </div>
                <h3 className="text-xl font-bold text-white mb-3">{feature.title}</h3>
                <p className="text-gray-400 leading-relaxed text-sm">{feature.description}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Features;